// Fragment "onboarding" — merged into ./index.js by mergeFragments.
// Convention: flat dotted keys, a value in all 3 languages, never empty.
//
// `onboarding.specialty.*` / `onboarding.country.*` are the label texts of the signup
// picker, and they are the ONLY copy of them: i18n/practiceTaxonomy.js maps each stored
// value to the key here and resolves it per render. Translating an entry below is safe
// and expected; the stored values in that module are frozen and are not labels.
export default {
  fr: {
    "onboarding.welcome.title": "Bienvenue sur Solunary",
    "onboarding.welcome.subtitle": "Configurons ton cabinet en 4 étapes.",

    "onboarding.steps.profile": "Profil",
    "onboarding.steps.specialty": "Spécialité",
    "onboarding.steps.branding": "Branding",
    "onboarding.steps.summary": "Récapitulatif",

    "onboarding.step0.title": "Ton profil",
    "onboarding.step0.subtitle": "Ces infos apparaîtront sur ta page « À propos ».",
    "onboarding.step0.phone.label": "Téléphone *",
    "onboarding.step0.phone.placeholder": "+1 514 555-0100",
    "onboarding.step0.photo.label": "Photo de profil",
    "onboarding.step0.bio.label": "Bio courte *",
    "onboarding.step0.bio.placeholder": "Quelques lignes sur ton parcours et ta vision...",

    "onboarding.step1.title": "Spécialité",
    "onboarding.step1.subtitle": "Choisis ta spécialité principale et ton pays d'exercice.",
    "onboarding.step1.specialty.label": "Spécialité *",
    "onboarding.step1.country.label": "Pays *",
    "onboarding.step1.country.placeholder": "Sélectionner...",

    "onboarding.step2.title": "Branding",
    "onboarding.step2.subtitle": "Ton identité visuelle. Tu pourras tout modifier ensuite.",
    "onboarding.step2.tagline.label": "Tagline",
    "onboarding.step2.tagline.placeholder": "Un voyage vers le bien-être",
    "onboarding.step2.color.primary": "Primaire",
    "onboarding.step2.color.accent": "Accent",
    "onboarding.step2.color.secondary": "Secondaire",
    "onboarding.step2.logo.label": "Logo",
    "onboarding.step2.hero.label": "Image hero",

    "onboarding.step3.title": "Récapitulatif",
    "onboarding.step3.subtitle": "Tout est prêt ! Vérifie une dernière fois.",
    "onboarding.step3.specialty.label": "Spécialité :",
    "onboarding.step3.country.label": "Pays :",
    "onboarding.step3.phone.label": "Téléphone :",

    "onboarding.upload.generic": "Téléverser",
    "onboarding.upload.logo": "Téléverser logo",
    "onboarding.upload.hero": "Téléverser hero",

    "onboarding.nav.next": "Suivant",
    "onboarding.nav.finish": "Terminer",

    "onboarding.toast.success": "Cabinet configuré avec succès !",
    "onboarding.toast.error": "Erreur",
    "onboarding.toast.uploadError": "Upload échoué",

    "onboarding.specialty.naturopathy": "Naturopathie",
    "onboarding.specialty.osteopathy": "Ostéopathie",
    "onboarding.specialty.acupuncture": "Acupuncture",
    "onboarding.specialty.kinesiology": "Kinésiologie",
    "onboarding.specialty.massage_therapy": "Massothérapie",
    "onboarding.specialty.functional_medicine": "Médecine fonctionnelle",
    "onboarding.specialty.holistic_nutrition": "Nutrition holistique",
    "onboarding.specialty.reflexology": "Réflexologie",
    "onboarding.specialty.homeopathy": "Homéopathie",
    "onboarding.specialty.hypnotherapy": "Hypnothérapie",
    "onboarding.specialty.other": "Autre",

    "onboarding.country.canada": "Canada",
    "onboarding.country.united_states": "États-Unis",
    "onboarding.country.france": "France",
    "onboarding.country.belgium": "Belgique",
    "onboarding.country.switzerland": "Suisse",
    "onboarding.country.united_kingdom": "Royaume-Uni",
    "onboarding.country.morocco": "Maroc",
    "onboarding.country.senegal": "Sénégal",
    "onboarding.country.india": "Inde",
    "onboarding.country.other": "Autre",
  },
  en: {
    "onboarding.welcome.title": "Welcome to Solunary",
    "onboarding.welcome.subtitle": "Let's set up your practice in 4 steps.",

    "onboarding.steps.profile": "Profile",
    "onboarding.steps.specialty": "Specialty",
    "onboarding.steps.branding": "Branding",
    "onboarding.steps.summary": "Summary",

    "onboarding.step0.title": "Your profile",
    "onboarding.step0.subtitle": "This info will appear on your \"About\" page.",
    "onboarding.step0.phone.label": "Phone *",
    "onboarding.step0.phone.placeholder": "+1 514 555-0100",
    "onboarding.step0.photo.label": "Profile photo",
    "onboarding.step0.bio.label": "Short bio *",
    "onboarding.step0.bio.placeholder": "A few lines about your background and your vision...",

    "onboarding.step1.title": "Specialty",
    "onboarding.step1.subtitle": "Choose your main specialty and your country of practice.",
    "onboarding.step1.specialty.label": "Specialty *",
    "onboarding.step1.country.label": "Country *",
    "onboarding.step1.country.placeholder": "Select...",

    "onboarding.step2.title": "Branding",
    "onboarding.step2.subtitle": "Your visual identity. You'll be able to change everything later.",
    "onboarding.step2.tagline.label": "Tagline",
    "onboarding.step2.tagline.placeholder": "A journey toward wellness",
    "onboarding.step2.color.primary": "Primary",
    "onboarding.step2.color.accent": "Accent",
    "onboarding.step2.color.secondary": "Secondary",
    "onboarding.step2.logo.label": "Logo",
    "onboarding.step2.hero.label": "Hero image",

    "onboarding.step3.title": "Summary",
    "onboarding.step3.subtitle": "Everything is ready! Check it one last time.",
    "onboarding.step3.specialty.label": "Specialty:",
    "onboarding.step3.country.label": "Country:",
    "onboarding.step3.phone.label": "Phone:",

    "onboarding.upload.generic": "Upload",
    "onboarding.upload.logo": "Upload logo",
    "onboarding.upload.hero": "Upload hero",

    "onboarding.nav.next": "Next",
    "onboarding.nav.finish": "Finish",

    "onboarding.toast.success": "Practice set up successfully!",
    "onboarding.toast.error": "Error",
    "onboarding.toast.uploadError": "Upload failed",

    "onboarding.specialty.naturopathy": "Naturopathy",
    "onboarding.specialty.osteopathy": "Osteopathy",
    "onboarding.specialty.acupuncture": "Acupuncture",
    "onboarding.specialty.kinesiology": "Kinesiology",
    "onboarding.specialty.massage_therapy": "Massage therapy",
    "onboarding.specialty.functional_medicine": "Functional medicine",
    "onboarding.specialty.holistic_nutrition": "Holistic nutrition",
    "onboarding.specialty.reflexology": "Reflexology",
    "onboarding.specialty.homeopathy": "Homeopathy",
    "onboarding.specialty.hypnotherapy": "Hypnotherapy",
    "onboarding.specialty.other": "Other",

    "onboarding.country.canada": "Canada",
    "onboarding.country.united_states": "United States",
    "onboarding.country.france": "France",
    "onboarding.country.belgium": "Belgium",
    "onboarding.country.switzerland": "Switzerland",
    "onboarding.country.united_kingdom": "United Kingdom",
    "onboarding.country.morocco": "Morocco",
    "onboarding.country.senegal": "Senegal",
    "onboarding.country.india": "India",
    "onboarding.country.other": "Other",
  },
  es: {
    "onboarding.welcome.title": "Bienvenido a Solunary",
    "onboarding.welcome.subtitle": "Configuremos tu consulta en 4 pasos.",

    "onboarding.steps.profile": "Perfil",
    "onboarding.steps.specialty": "Especialidad",
    "onboarding.steps.branding": "Marca",
    "onboarding.steps.summary": "Resumen",

    "onboarding.step0.title": "Tu perfil",
    "onboarding.step0.subtitle": "Esta información aparecerá en tu página \"Acerca de\".",
    "onboarding.step0.phone.label": "Teléfono *",
    "onboarding.step0.phone.placeholder": "+1 514 555-0100",
    "onboarding.step0.photo.label": "Foto de perfil",
    "onboarding.step0.bio.label": "Biografía breve *",
    "onboarding.step0.bio.placeholder": "Algunas líneas sobre tu trayectoria y tu visión...",

    "onboarding.step1.title": "Especialidad",
    "onboarding.step1.subtitle": "Elige tu especialidad principal y tu país de ejercicio.",
    "onboarding.step1.specialty.label": "Especialidad *",
    "onboarding.step1.country.label": "País *",
    "onboarding.step1.country.placeholder": "Seleccionar...",

    "onboarding.step2.title": "Marca",
    "onboarding.step2.subtitle": "Tu identidad visual. Podrás modificarlo todo después.",
    "onboarding.step2.tagline.label": "Eslogan",
    "onboarding.step2.tagline.placeholder": "Un viaje hacia el bienestar",
    "onboarding.step2.color.primary": "Primario",
    "onboarding.step2.color.accent": "Acento",
    "onboarding.step2.color.secondary": "Secundario",
    "onboarding.step2.logo.label": "Logo",
    "onboarding.step2.hero.label": "Imagen principal",

    "onboarding.step3.title": "Resumen",
    "onboarding.step3.subtitle": "¡Todo está listo! Revísalo una última vez.",
    "onboarding.step3.specialty.label": "Especialidad:",
    "onboarding.step3.country.label": "País:",
    "onboarding.step3.phone.label": "Teléfono:",

    "onboarding.upload.generic": "Subir",
    "onboarding.upload.logo": "Subir logo",
    "onboarding.upload.hero": "Subir imagen principal",

    "onboarding.nav.next": "Siguiente",
    "onboarding.nav.finish": "Finalizar",

    "onboarding.toast.success": "¡Consulta configurada con éxito!",
    "onboarding.toast.error": "Error",
    "onboarding.toast.uploadError": "Error al subir",

    "onboarding.specialty.naturopathy": "Naturopatía",
    "onboarding.specialty.osteopathy": "Osteopatía",
    "onboarding.specialty.acupuncture": "Acupuntura",
    "onboarding.specialty.kinesiology": "Kinesiología",
    "onboarding.specialty.massage_therapy": "Masoterapia",
    "onboarding.specialty.functional_medicine": "Medicina funcional",
    "onboarding.specialty.holistic_nutrition": "Nutrición holística",
    "onboarding.specialty.reflexology": "Reflexología",
    "onboarding.specialty.homeopathy": "Homeopatía",
    "onboarding.specialty.hypnotherapy": "Hipnoterapia",
    "onboarding.specialty.other": "Otro",

    "onboarding.country.canada": "Canadá",
    "onboarding.country.united_states": "Estados Unidos",
    "onboarding.country.france": "Francia",
    "onboarding.country.belgium": "Bélgica",
    "onboarding.country.switzerland": "Suiza",
    "onboarding.country.united_kingdom": "Reino Unido",
    "onboarding.country.morocco": "Marruecos",
    "onboarding.country.senegal": "Senegal",
    "onboarding.country.india": "India",
    "onboarding.country.other": "Otro",
  },
};
